import React from 'react';
import { Navigation } from '../components/Navigation';
import { GoogleReviewsSection } from '../components/GoogleReviewsSection';
import { ReviewsCarousel } from '@/components/ReviewsCarousel';
import { Footer } from '../components/Footer';


const ReviewsPage = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <div className="pt-20">
        <GoogleReviewsSection />
        <ReviewsCarousel />
      </div>
      <Footer />
    </div>
  );
};

export default ReviewsPage;
